module.exports = __webpack_public_path__ + "static/media/bg5.4b7629c5.jpg";